import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { Row, Col, Form, FormGroup, Label } from "reactstrap";
import CommonSelect from "../../../Basic/Select";
import { getCountry, getTimeZone } from "../../api";
import { userData } from "../data";
import { scrollToSelect } from "../../utils/utils";
import { getTransFunc } from '../../../Basic/SFxLocalization';
import { cloneDeep } from 'lodash';

var languageAndRegin = /*#__PURE__*/function (_React$Component) {
  _inherits(languageAndRegin, _React$Component);

  var _super = _createSuper(languageAndRegin);

  function languageAndRegin() {
    var _this;

    _classCallCheck(this, languageAndRegin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      languageRegion: {
        language: cloneDeep(userData.languageRegion.language),
        timeZone: userData.languageRegion.timeZone,
        country: userData.languageRegion.country
      },
      timeZoneChangeAble: false,
      isTimeZoneLoading: false,
      countryList: userData.staticSource.countryList || []
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.setState = function () {
        return;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "initTimeZoneList", function () {
      if (userData.staticSource.countryList && _this.state.languageRegion.country) {
        var countryId = _this.state.languageRegion.country.geonameId;
        var currentCountry = userData.staticSource.countryList.filter(function (item) {
          return item.geonameId === countryId;
        });

        if (currentCountry && currentCountry[0]) {
          var countryCode = currentCountry[0].countryCode;

          _this.getTimeZoneList(countryCode);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCountryList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getCountry({
                catchError: true
              });

            case 3:
              res = _context.sent;

              if (res && res.data) {
                userData.staticSource.countryList = res.data;

                _this.initTimeZoneList();

                _this.setState({
                  countryList: res.data
                });
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getTimeZoneList", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(countryCode) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({
                  isTimeZoneLoading: true
                });

                _context2.prev = 1;
                _context2.next = 4;
                return getTimeZone(countryCode, {
                  catchError: true
                });

              case 4:
                res = _context2.sent;

                if (res && res.data) {
                  userData.staticSource.timeZone = res.data;

                  _this.setState({
                    timeZone: res.data,
                    timeZoneChangeAble: true,
                    isTimeZoneLoading: false
                  });
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (item, name) {
      var languageRegion = Object.assign(_this.state.languageRegion, _defineProperty({}, name, item));

      if (name === "country") {
        _this.setState({
          timeZoneChangeAble: false
        });

        _this.getTimeZoneList(item.countryCode);

        languageRegion = _objectSpread(_objectSpread({}, _this.state.languageRegion), {
          country: item,
          timeZone: null
        });
      }

      _this.setState({
        languageRegion: languageRegion
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveData", function () {
      userData.languageRegion = _objectSpread({}, _this.state.languageRegion);
    });

    _defineProperty(_assertThisInitialized(_this), "resetData", function () {
      var languageRegion = _objectSpread({}, userData.languageRegion);

      _this.setState({
        languageRegion: languageRegion
      });
    });

    return _this;
  }

  _createClass(languageAndRegin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.childEvent({
        saveData: this.saveData,
        resetData: this.resetData
      });

      if (!userData.staticSource.countryList) {
        this.getCountryList();
      } else {
        this.initTimeZoneList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var trans = getTransFunc();
      var languageRegion = this.state.languageRegion;
      var solutionName = this.props.options.solutionName ? this.props.options.solutionName : '';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, trans('SFxUserProfileWelcomeContent', solutionName)), /*#__PURE__*/React.createElement("p", null, trans('SFxUserProfileForewordContent')), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "25px"
        }
      }, trans('SFxUserProfileStartContent')), /*#__PURE__*/React.createElement(Form, {
        id: "languageAnchor"
      }, /*#__PURE__*/React.createElement(Row, {
        form: true
      }, /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "exampleSelect"
      }, trans('SFxUserProfileCountry')), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        showFlag: true,
        renderOption: function renderOption(i) {
          return {
            label: i.countryName,
            value: i.geonameId
          };
        },
        value: languageRegion.country,
        options: this.state.countryList,
        onChange: function onChange(item) {
          return _this2.onSelectChange(item, "country");
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "exampleSelect"
      }, trans('SFxUserProfileLanguage')), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        value: languageRegion.language,
        options: userData.staticSource.supportedLanguages,
        onChange: function onChange(item) {
          return _this2.onSelectChange(item, "language");
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "companyFacility"
      }, trans('SFxUserProfileTimeZone')), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        renderOption: function renderOption(i) {
          return {
            label: i && i.DstOffset,
            value: i && i.DstOffset
          };
        },
        value: languageRegion.timeZone,
        isLoading: this.state.isTimeZoneLoading,
        isDisabled: !this.state.timeZoneChangeAble,
        noOptionsMessage: function noOptionsMessage() {
          return trans('SFxUserTimeZoneSelectCountryFirst');
        },
        options: userData.staticSource.timeZone,
        onChange: function onChange(item) {
          return _this2.onSelectChange(item, "timeZone");
        }
      }))))));
    }
  }]);

  return languageAndRegin;
}(React.Component);

export { languageAndRegin as default };